<template>
  <div>
    <Head title="QC Returns Issuances" />
    <h1 class="mb-8 text-3xl font-bold">QC Returns Issuances</h1>
    <div class="bg-white rounded-md shadow mb-5">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-2 -mr-6 pt-8 pl-8 pr-8 pb-8">
          <div class="pb-2 pr-6 mb-3 w-full lg:w-full">
            <Checkbox label="Cushions" :active="cushion" @input="cushion = $event"/>
          </div>
          <div class="w-1/3 lg:w-1/3 pb-2 pr-6">
            <multiselect
              id="location"
              v-model="selectedLocation"
              placeholder="Search Location"
              :options="issuance_locations"
              :close-on-select="true"
              :searchable="true"
              :error="form.errors.location"
              :style="form.errors.location ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
              @search-change="onSearchLocationChange"
              @input="onSelectedLocation"
            />
            <div v-if="form.errors.location" class="form-error">{{ form.errors.location }}</div>
          </div>
          <div class="w-1/3 lg:w-1/3 pb-2 pr-6">
            <multiselect
              id="reason"
              v-model="selectedDetermination"
              placeholder="Search Determination"
              :options="determinations"
              :close-on-select="true"
              :searchable="true"
              :error="form.errors.determination"
              :style="form.errors.determination ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
              @search-change="onSearchDeterminationChange"
              @input="onSelectedDetermination"
            />
            <div v-if="form.errors.determination" class="form-error">{{ form.errors.determination }}</div>
          </div>
          <div v-show="cushion" class="w-1/3 lg:w-1/3">
            <text-input
              v-model="form.quantity"
              :error="form.errors.quantity"
              class="pb-2 pr-6 w-full lg:w-full"
              placeholder="Quantity"
            />
          </div>
          <div v-show="cushion" class="w-full lg:w-full">
            <text-input
              v-model="form.part_number"
              :error="form.errors.part_number"
              class="pb-2 pr-6 w-full lg:w-full"
              placeholder="Scan Part Number"
            />
          </div>
          <div v-show="!cushion" class="w-1/3 lg:w-1/3">
            <text-input
              v-model="form.item_id"
              :error="form.errors.item_id"
              class="pb-2 pr-6 w-full lg:w-full"
              placeholder="Scan UID"
            />
          </div>
        </div>
        <div
          class="flex items-center justify-end w-full px-8 py-4 bg-gray-50 border-t border-gray-100"
        >
          <loading-button
            :loading="form.processing"
            class="btn-orange px-3 py-2 text-xs"
            type="submit"
          >
            Add Returned Item Issuance
          </loading-button>
        </div>
      </form>
    </div>
    <hr />
    <ul
      id="tabs-tabFill" class="nav nav-tabs flex flex-col md:flex-row flex-wrap list-none border-b-0 pl-0 mb-4"
      role="tablist"
    >
      <li class="nav-item flex-auto text-center" role="presentation">
        <a
          id="tabs-home-tabFill" href="#tabs-homeFill" class="
            nav-link
            w-full
            block
            font-medium
            text-xs
            leading-tight
            uppercase
            border-x-0 border-t-0 border-b-2 border-transparent
            px-6
            py-3
            my-2
            hover:border-transparent hover:bg-gray-100
            focus:border-transparent
            active
          " data-bs-toggle="pill" data-bs-target="#tabs-homeFill" role="tab"
          aria-controls="tabs-homeFill" aria-selected="true"
        >Today's Scans</a>
      </li>
      <li class="nav-item flex-auto text-center" role="presentation">
        <a
          id="tabs-profile-tabFill" href="#tabs-profileFill" class="
            nav-link
            w-full
            block
            font-medium
            text-xs
            leading-tight
            uppercase
            border-x-0 border-t-0 border-b-2 border-transparent
            px-6
            py-3
            my-2
            hover:border-transparent hover:bg-gray-100
            focus:border-transparent
          " data-bs-toggle="pill" data-bs-target="#tabs-profileFill" role="tab"
          aria-controls="tabs-profileFill" aria-selected="false"
        >All Scans</a>
      </li>
      <li class="nav-item flex-auto text-center" role="presentation">
        <a
          id="tabs-summary-tabFill" href="#tabs-summaryFill" class="
            nav-link
            w-full
            block
            font-medium
            text-xs
            leading-tight
            uppercase
            border-x-0 border-t-0 border-b-2 border-transparent
            px-6
            py-3
            my-2
            hover:border-transparent hover:bg-gray-100
            focus:border-transparent
          " data-bs-toggle="pill" data-bs-target="#tabs-summaryFill" role="tab"
          aria-controls="tabs-summaryFill" aria-selected="false"
        >Summaries</a>
      </li>
    </ul>
    <div id="tabs-tabContentFill" class="tab-content">
      <div id="tabs-homeFill" class="tab-pane fade show active" role="tabpanel" aria-labelledby="tabs-home-tabFill">
        <div class="bg-white rounded-md shadow overflow-x-auto mt-5">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-3 pt-3 px-3">Date</th>
              <th class="pb-3 pt-3 px-3">Item UID</th>
              <th class="pb-3 pt-3 px-3">Part Number.</th>
              <th class="pb-3 pt-3 px-3">Description</th>
              <th class="pb-3 pt-3 px-3 text-center">Quantity</th>
              <th class="pb-3 pt-3 px-3">UoM</th>
              <th class="pb-3 pt-3 px-3">Location</th>
              <th class="pb-3 pt-3 px-3">Determination</th>
              <th class="pb-3 pt-3 px-3" colspan="2">User</th>
            </tr>
            <tr v-for="item in returnedItemIssuances.data" :key="item.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
              <td class="border-t">
                <Link class="flex items-center px-3 py-2 focus:text-orange-500">
                  {{ item.date }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.item_uid }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.part_no }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.description }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2 text-center" tabindex="-1">
                  {{ item.quantity }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.measure }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.location }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.determination }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ item.user }}
                </Link>
              </td>
              <td class="w-px border-t">
                <Link class="flex items-center px-3" tabindex="-1">
                  <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
                </Link>
              </td>
            </tr>
            <tr v-if="returnedItemIssuances.data.length === 0">
              <td class="px-6 py-4 border-t" colspan="8">No data found</td>
            </tr>
          </table>
        </div>
        <pagination class="mt-6" :links="returnedItemIssuances.links" />
      </div>
      <div id="tabs-profileFill" class="tab-pane fade" role="tabpanel" aria-labelledby="tabs-profile-tabFill">
        <div class="flex items-center justify-between mb-6">
          <date-range v-model="search.dateValue" class="mr-0 w-full max-w-md mr-3" @reset="reset" />
          <a
            v-if="allReturnedItemIssuances.data.length > 0"
            class="btn-orange px-3 py-2 text-xs cursor-pointer"
            :href="`/returned-item-issuances/download/${search.dateValue}`"
            download
            target="__blank"
          >
            <span>Download</span>
          </a>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto mt-5">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-3 pt-3 px-3">Date</th>
              <th class="pb-3 pt-3 px-3">Item UID</th>
              <th class="pb-3 pt-3 px-3">Part Number.</th>
              <th class="pb-3 pt-3 px-3">Description</th>
              <th class="pb-3 pt-3 px-3 text-center">Quantity</th>
              <th class="pb-3 pt-3 px-3">UoM</th>
              <th class="pb-3 pt-3 px-3">Location</th>
              <th class="pb-3 pt-3 px-3">Determination</th>
              <th class="pb-3 pt-3 px-3" colspan="2">User</th>
            </tr>
            <tr v-for="issuanceh in allReturnedItemIssuances.data" :key="issuanceh.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
              <td class="border-t">
                <Link class="flex items-center px-3 py-2 focus:text-orange-500">
                  {{ issuanceh.date }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ issuanceh.item_uid }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ issuanceh.part_no }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ issuanceh.description }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2 text-center" tabindex="-1">
                  {{ issuanceh.quantity }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ issuanceh.measure }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ issuanceh.location }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ issuanceh.determination }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-3 py-2" tabindex="-1">
                  {{ issuanceh.user }}
                </Link>
              </td>
              <td class="w-px border-t">
                <Link class="flex items-center px-3" tabindex="-1">
                  <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
                </Link>
              </td>
            </tr>
            <tr v-if="allReturnedItemIssuances.length === 0">
              <td class="px-6 py-4 border-t" colspan="8">No data found</td>
            </tr>
          </table>
        </div>
        <pagination class="mt-6" :links="allReturnedItemIssuances.links" />
      </div>
      <div id="tabs-summaryFill" class="tab-pane fade" role="tabpanel" aria-labelledby="tabs-summary-tabFill">
        <div class="flex items-center justify-between mb-6">
          <date-range v-model="summary.dateRange" class="mr-0 w-full max-w-md" @reset="resets" />
          <a
            v-if="returnedItemSummaries.data.length > 0"
            class="btn-orange px-3 py-2 text-xs cursor-pointer"
            :href="`/returned-item-issuances/summary/download/${summary.dateRange}`"
            download
            target="__blank"
          >
            <span>Download</span>
          </a>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-2 pt-2 px-3">Part Number</th>
              <th class="pb-2 pt-2 px-3">Part Description</th>
              <th class="pb-2 pt-2 px-3">Category</th>
              <th class="pb-2 pt-2 px-3">Count</th>
              <th class="pb-2 pt-2 px-3">Quantity</th>
              <th class="pb-2 pt-2 px-3">UoM</th>
              <th class="pb-2 pt-2 px-3">Location</th>
              <th class="pb-2 pt-2 px-3">Determination</th>
            </tr>
            <tr
              v-for="inventory in returnedItemSummaries.data"
              :key="inventory.sku_name"
              class="hover:bg-orange-100 focus-within:bg-gray-100"
            >
              <td class="border-t">
                <span class="flex items-center px-3 py-2 focus:text-indigo-500">
                  {{ inventory.sku_name }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-3 py-2 focus:text-indigo-500">
                  {{ inventory.description }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-3 py-2 focus:text-indigo-500">
                  {{ inventory.category }}
                </span>
              </td>
              <td class="w-px border-t">
                <span class="flex items-center px-3 py-2 focus:text-indigo-500 text-right">
                  {{ inventory.total }}
                </span>
              </td>
              <td class="w-px border-t">
                <span class="flex items-center px-3 py-2 focus:text-indigo-500 text-right">
                  {{ inventory.quantity }}
                </span>
              </td>
              <td class="w-px border-t text-center">
                <span class="flex items-center px-3 py-2 focus:text-indigo-500">
                  {{ inventory.unit_of_measure }}
                </span>
              </td>
              <td class="w-px border-t text-center">
                <span class="flex items-center px-3 py-2 focus:text-indigo-500">
                  {{ inventory.location }}
                </span>
              </td>
              <td class="w-px border-t text-center">
                <span class="flex items-center px-3 py-2 focus:text-indigo-500">
                  {{ inventory.determination }}
                </span>
              </td>
            </tr>
            <tr v-if="returnedItemSummaries.length === 0">
              <td class="px-6 py-4 border-t" colspan="8">No data found</td>
            </tr>
          </table>
        </div>
        <pagination class="mt-6" :links="returnedItemSummaries.links" />
      </div>
    </div>
  </div>
</template>
  
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
//import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Pagination from '@/Shared/Pagination'
import DateRange from '@/Shared/DateRange'
import Multiselect from '@vueform/multiselect'
import Checkbox from '@/Shared/Checkbox'
  
export default {
  components: {
    Head,
    Link,
    DateRange,
    TextInput,
    SelectInput,
    LoadingButton,
    Pagination,
    Multiselect,
    Checkbox,
  },
  layout: Layout,
  props: {
    filters: Object,
    returnedItemIssuances: Object,
    determinations: Object,
    allReturnedItemIssuances: Object,
    returnedItemSummaries: Object,
    issuance_locations: Object,
  },
  data() {
    return {
      cushion: false,
      form: this.$inertia.form({
        item_id: null,
        location: null,
        determination: null,
        part_number: null,
        quantity: null,
      }),
      search: {
        dateValue: this.filters.dateValue,
      },
      summary: {
        dateRange: this.filters.dateRange,
      },
      selectedLocation: null,
      selectedDetermination: null,
    }
  },
  computed: {
    role() {
      return this.$inertia.page.props.auth.user.role
    },
  },
  watch: {
    search: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/returned-item-issuances/', pickBy(this.search), { preserveState: true })
      }, 150),
    },
    summary: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/returned-item-issuances/', pickBy(this.summary), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.search = mapValues(this.search, () => null)
    },
    resets() {
      this.summary = mapValues(this.summary, () => null)
    },
    store() {
      this.form.transform(({...data }) => ({
        has_cushion: this.cushion,
        ...data,
      }))
      this.form.post('/returned-item-issuances', {
        onSuccess: () => {
          this.form.reset(
            'item_id',
            'issuance_team',
            'quantity',
            'part_number'
          )
        },
      })
    },
    onSelectedLocation(location, id) {
      this.form.location = location
      this.selectedLocation = location
    },
    onSearchLocationChange: throttle(function () {
    }),
    onSelectedDetermination(determination, id) {
      this.form.determination = determination
      this.selectedDetermination = determination
    },
    onSearchDeterminationChange: throttle(function () {
    }),
  },
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style type="text/css">
  .multiselect-option.is-selected.is-pointed {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
  .multiselect-option.is-selected {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
</style>